import React from 'react';
import { styled } from 'mz-ui-kit'
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  UpgradesContainer,
  mapDispatchToProps,
  mapStateToProps
} from 'app/components/book-trip/UpgradeYourTrip/commons/UpgradesContainer';
import { UPGRADE_IDS } from 'app/constants';


const Container = styled('div', {
  marginTop: '2em',
})

function SmsNotificationsAmenity(props) {
  const onlySmsAmenity = props.upgrades
    .filter(
      (a) => a.id === UPGRADE_IDS.SMS_NOTIFICATION || a.id === UPGRADE_IDS.ESIM
    )
    .map((a) => ({
      ...a,
      order: a.id === UPGRADE_IDS.SMS_NOTIFICATION ? 1 : 0,
    }))
    .sort((a, b) => b.order - a.order);
  if (!onlySmsAmenity.length) return null

  return <Container><UpgradesContainer {...props} upgrades={onlySmsAmenity} /></Container>
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(SmsNotificationsAmenity);
